export const ProcessStep = ({ index, title, body, accent = "bg-roseMilk", testId }) => (
  <div className="wit-bento-cell flex flex-col h-full" data-testid={testId || `process-step-${index}`}>
    <div className={`w-10 h-10 rounded-full ${accent} text-plum font-serif text-base flex items-center justify-center mb-4`}>
      {index}
    </div>
    <h3 className="font-serif text-lg text-ink mb-2">{title}</h3>
    <p className="text-sm text-warmGrey leading-relaxed">{body}</p>
  </div>
);

export default ProcessStep;
